import { create } from 'zustand'

import {
  getConsumptionTypes,
  createNewOtherConsumption,
  getOtherConsumptions,
  editOtherConsumption,
  removeOtherConsumption,
  getClassifiedConsumption,
  getDetailedSummary,
  getDetailedSummaryV2,
  editDetailedSummary,
  getWeeklyBreakdown,
  getBigNumbersConsumption,
  getConsumptionAveragePercentages,
  approvalWorkflowConsumption,
  reverseWorkflowConsumption,
  releasePreviewConsumption,
  reversePreviewConsumption
} from './provider'

import type { UseConsumptionProps } from './types'

export const useConsumption = create<UseConsumptionProps>((set) => ({
  consumptionTypes: [],
  setConsumptionTypes: (data) => set({ consumptionTypes: data }),

  consumptionTypesLoading: false,
  setConsumptionTypesLoading: (value) => set({ consumptionTypesLoading: value }),

  createNewOtherConsumptionLoading: false,
  setCreateNewOtherConsumptionLoading: (value) => set({ createNewOtherConsumptionLoading: value }),

  otherConsumptionsData: null,
  setOtherConsumptionsData: (data) => set({ otherConsumptionsData: data }),

  otherConsumptionsLoading: false,
  setOtherConsumptionsLoading: (value) => set({ otherConsumptionsLoading: value }),

  isRemoveOtherConsumptionLoading: false,
  setIsRemoveOtherConsumptionLoading: (value) => set({ isRemoveOtherConsumptionLoading: value }),

  classifiedConsumptionData: null,
  setClassifiedConsumptionData: (data) => set({ classifiedConsumptionData: data }),

  isClassifiedConsumptionLoading: false,
  setIsClassifiedConsumptionLoading: (value) => set({ isClassifiedConsumptionLoading: value }),

  detailedSummaryData: null,
  setDetailedSummaryData: (data) => set({ detailedSummaryData: data }),

  isDetailedSummaryLoading: false,
  setIsDetailedSummaryLoading: (value) => set({ isDetailedSummaryLoading: value }),

  detailedSummaryV2Data: null,
  setDetailedSummaryV2Data: (data) => set({ detailedSummaryV2Data: data }),

  isDetailedSummaryV2Loading: false,
  setIsDetailedSummaryV2Loading: (value) => set({ isDetailedSummaryV2Loading: value }),

  weeklyBreakdownData: null,
  setWeeklyBreakdownData: (data) => set({ weeklyBreakdownData: data }),

  isWeeklyBreakdownLoading: false,
  setIsWeeklyBreakdownLoading: (value) => set({ isWeeklyBreakdownLoading: value }),

  isEditDetailedSummaryLoading: false,
  setIsEditDetailedSummaryLoading: (value) => set({ isEditDetailedSummaryLoading: value }),

  bigNumbersConsumptionData: null,
  setBigNumbersConsumptionData: (data) => set({ bigNumbersConsumptionData: data }),

  isBigNumbersConsumptionLoading: false,
  setIsBigNumbersConsumptionLoading: (value) => set({ isBigNumbersConsumptionLoading: value }),

  consumptionAveragePercentagesData: null,
  setConsumptionAveragePercentagesData: (data) => set({ consumptionAveragePercentagesData: data }),

  isConsumptionAveragePercentagesLoading: false,
  setIsConsumptionAveragePercentagesLoading: (value) => set({ isConsumptionAveragePercentagesLoading: value }),

  isApprovalWorkflowConsumptionLoading: false,
  setIsApprovalWorkflowConsumptionLoading: (value) => set({ isApprovalWorkflowConsumptionLoading: value }),

  isReverseWorkflowConsumptionLoading: false,
  setIsReverseWorkflowConsumptionLoading: (value) => set({ isReverseWorkflowConsumptionLoading: value }),

  isReleasePreviewConsumptionLoading: false,
  setIsReleasePreviewConsumptionLoading: (value) => set({ isReleasePreviewConsumptionLoading: value }),

  isReversePreviewConsumptionLoading: false,
  setIsReversePreviewConsumptionLoading: (value) => set({ isReversePreviewConsumptionLoading: value }),

  getConsumptionTypes,
  createNewOtherConsumption,
  getOtherConsumptions,
  editOtherConsumption,
  removeOtherConsumption,
  getClassifiedConsumption,
  getDetailedSummary,
  getDetailedSummaryV2,
  getWeeklyBreakdown,
  editDetailedSummary,
  getBigNumbersConsumption,
  getConsumptionAveragePercentages,
  approvalWorkflowConsumption,
  reverseWorkflowConsumption,
  releasePreviewConsumption,
  reversePreviewConsumption
}))
